import React, { FunctionComponent, lazy, Suspense } from 'react'
import { Switch } from 'react-router'
import ProtectedRoute from '../../etc/ProtectedRoute'
import { ROUTES } from '../../../http/routes'
import { loginRule } from '../../../constants/route-rules'

const TasksList = lazy(() => import('./TasksList/TaskList'))
const SingleTask = lazy(() => import('./TaskPage/TaskPage'))

const TasksPage: FunctionComponent = () => <Suspense fallback={<div/>}>
    <Switch>
        <ProtectedRoute
            path={ROUTES.TASK}
            component={SingleTask}
            rules={[loginRule]}
        />
        <ProtectedRoute
            path={ROUTES.TASKS}
            component={TasksList}
            rules={[loginRule]}
        />
    </Switch>
</Suspense>

export default TasksPage